/**
 * Sanitizes a string for safe use as a filename across Windows, macOS, and Linux.
 * Replaces characters that are invalid or problematic in filenames with a dash,
 * trims surrounding whitespace, and removes trailing dots.
 *
 * Invalid characters replaced: / \ : * ? " < > |
 */
export const sanitizeFilename = (name: string): string => {
  return name
    .replace(/[/\\:*?"<>|]/g, '-')
    .trim()
    .replace(/\.+$/, '');
};
